import Route from '@ember/routing/route'
import { task, timeout } from 'ember-concurrency'
import { service } from '@ember/service'
import { Product } from 'teacher-ui-client/utils/products'
import type { Precinct } from 'teacher-ui-client/utils/precincts'
import { isPrecinct, isValidPrecinctForProduct, defaultPrecinctForProduct } from 'teacher-ui-client/utils/precincts'
import type ContentfulClient from 'teacher-ui-client/services/contentful-client'
import { queryParam } from 'teacher-ui-client/decorators/query-param'

export default class FpLessonsVideosPage extends Route {
  @service contentfulClient!: ContentfulClient

  @queryParam('subscription-type/lessons') precinct!: string

  model() {
    const precinct =
      isPrecinct(this.precinct) && isValidPrecinctForProduct(Product.FP, this.precinct)
        ? this.precinct
        : defaultPrecinctForProduct(Product.FP)

    const precincts = [precinct]

    return { loaderInstance: this.fetchEntries.perform(precincts) }
  }

  fetchEntries = task({ restartable: true }, async (precincts: Precinct[]) => {
    await timeout(500)
    return this.contentfulClient.getPrecinctResources(precincts, ['training_video'])
  })
}
